import { getDropdownOptions } from '@ben/columbia/api';
import Select from '@ben/orion/deprecated-select';
import type { ITag } from '@ben/shared/types/columbia';
import { useQuery } from '@tanstack/react-query';
import { memo, useCallback, useMemo, useRef } from 'react';
import AddTagModal from './add-tag-modal';

export interface ITagsSelect {
  onChange: (tags: ITag[]) => void;
  defaultValue: string[];
  hasError?: boolean;
  width?: string;
}

const TagsSelect = ({
  onChange,
  hasError,
  width,
  defaultValue,
}: ITagsSelect) => {
  const { isLoading, data } = useQuery([`dropdownOptionsFor-tags`], () =>
    getDropdownOptions('tags')
  );
  const addTagModalRef = useRef<{
    showModal: (tagName: string) => void;
  }>(null);
  const options = useMemo(() => {
    return isLoading || !data
      ? []
      : data.map((tag) => ({
          key: String(tag.id),
          label: String(tag.name),
        }));
  }, [data, isLoading]);

  const handleShowModal = useCallback(
    (tagName: string) => {
      addTagModalRef?.current?.showModal(tagName);
    },
    [addTagModalRef]
  );

  const handleOnChange = useCallback(
    (values: string[]) => {
      if (data) {
        const selectedTags = data.filter((tag) =>
          values.includes(String(tag.id))
        );
        onChange(selectedTags);
      }
    },
    [data, onChange]
  );
  return (
    <>
      <Select
        disabled={isLoading}
        options={options}
        name="Tags"
        placeholder="Select tags..."
        defaultValue={defaultValue}
        onChange={(values) => {
          handleOnChange(values as string[]);
        }}
        hasError={hasError}
        width={width}
        showSearch
        onCreateOption={handleShowModal}
        canCreateOption
      />
      <AddTagModal ref={addTagModalRef} />
    </>
  );
};

export default memo(TagsSelect);
